<template>
  <div>
    <template v-if="isIntegrationEnabled('constructor')">
      <slot name="constructor"></slot>
    </template>

    <template v-else>
      <slot name="original"></slot>
    </template>
  </div>
</template>

<script setup lang="ts">
const { isIntegrationEnabled } = useUtils()
</script>
